import extend from './extend.js';

export enum ConferenceType {
  Web = 1,
  Telephone = 2,
  WebAndPhone = 3,
  InPerson = 4,
}

const conferenceTypeMap = new Map([
  [ConferenceType.Web, { name: 'Web' }],
  [ConferenceType.Telephone, { name: 'Telephone' }],
  [ConferenceType.WebAndPhone, { name: 'Web + Phone' }],
  [ConferenceType.InPerson, { name: 'In-person' }],
]);

export enum ConferenceMediaType {
  Video = 1,
  Voice = 2,
}

const conferenceMediaTypeMap = new Map([
  [ConferenceMediaType.Video, { name: 'Video' }],
  [ConferenceMediaType.Voice, { name: 'Voice' }],
]);

export enum ConferencePlatform {
  Sentiment = 1,
  OffPlatform = 2,
}

const conferencePlatformMap = new Map([
  [ConferencePlatform.Sentiment, { name: 'Sentiment' }],
  [ConferencePlatform.OffPlatform, { name: 'Off Platform' }],
]);

export enum ConferenceFeatureShareType {
  EnabledForModerator = 1,
  EnabledForModeratorAndRespondent = 2,
  EnabledForAll = 3,
  DisabledForAll = 4,
}

const conferenceFeatureShareMap = new Map([
  [ConferenceFeatureShareType.EnabledForModerator, { name: 'Enabled for Moderator' }],
  [ConferenceFeatureShareType.EnabledForModeratorAndRespondent, { name: 'Enabled for Moderator + Respondent' }],
  [ConferenceFeatureShareType.EnabledForAll, { name: 'Enabled for All' }],
  [ConferenceFeatureShareType.DisabledForAll, { name: 'Disabled for All' }],
]);

export enum ConferenceCue {
  EnterPin = 1,
  InvalidPin = 2,
  Joined = 3,
  NoInput = 4,
  NotAuthorized = 5,
  Recording = 6,
  UnableToConnect = 7,
  WelcomeEnterPin = 8,
  WaitingRoomForApproval = 9,
  WaitingRoomForStart = 10,
}

const conferenceCueMap = new Map([
  [ConferenceCue.EnterPin, { name: 'Enter Pin' }],
  [ConferenceCue.InvalidPin, { name: 'Invalid Pin' }],
  [ConferenceCue.Joined, { name: 'Joined' }],
  [ConferenceCue.NoInput, { name: 'No Input' }],
  [ConferenceCue.NotAuthorized, { name: 'Not Authorized' }],
  [ConferenceCue.Recording, { name: 'Recording' }],
  [ConferenceCue.UnableToConnect, { name: 'Unable To Connect' }],
  [ConferenceCue.WelcomeEnterPin, { name: 'Welcome Enter Pin' }],
  [ConferenceCue.WaitingRoomForApproval, { name: 'Waiting Room for Approval' }],
  [ConferenceCue.WaitingRoomForStart, { name: 'Waiting Room for Start' }],
]);

export default {
  ConferenceType: extend(conferenceTypeMap),
  ConferenceMediaType: extend(conferenceMediaTypeMap),
  ConferencePlatform: extend(conferencePlatformMap),
  ConferenceFeatureShareType: extend(conferenceFeatureShareMap),
  ConferenceCue: extend(conferenceCueMap),

};

export enum ConferenceChatType {
  Group = 1,
  Direct = 2,
}

export enum ConferenceTagType {
  Project = 1,
  UserCreated = 2,
  Module = 3,
  Global = 4,
  Segmentation = 5,
}

// Name of the global conference tag used to mark project "Good Quote" highlights.
export const GOOD_QUOTE_TAG_NAME = 'Good Quote';

export enum ConferenceModule {
  CurrentTreatmentApproach = 1,
  FutureTreatmentApproach = 2,
  UnmetNeeds = 3,
  IntroAndBackground = 4,
  PatientSizeAndSegmentation = 5,
  BuyingAndBilling = 6,
  ProductAttributeAssessment = 7,
  OutroAndAdditionalQuestions = 8,
  ProfileReception = 9,
  BrandStoryReview = 10,
  FlashTest = 11,
  TPPReview = 12,
  PositioningStatementReview = 13,
  ConceptReview = 14,
  // DetailedConceptReview = 15,
  HeadToHeadComparison = 16,
  DiseaseStateAwareness = 17,
  MechanismOfActionAwareness = 18,
  MessageReview = 19,
  StoryFlow = 20,
  Origination = 21,
  EvaluationAndDiagnosis = 22,
  Treatment = 23,
  Monitoring = 24,
  ReactionToTPPs = 25,
  Impact = 26,
  DriversAndBarriers = 27,
  MockSalesDetail = 28,
  IndependentReview = 29,
  DetailedImageReview = 30,
  WrapUp = 31,
  PatientProfileEvaluation = 32,
  PremisePromiseProofReview = 33,
  RolePlayExercise = 34,
  SetupAndContext = 35,
  DiseaseAndLandscape = 36,
  FutureEnvironment = 37,
  EvidenceExpectations = 38,
  TrialDesignPerceptions = 39,
  TPPPerceptions = 40,
  AccessOpportunity = 41,
  TPPScenarioTesting = 42,
  MessagingToOptimizePAndT = 43,
  Close = 44,
  CBSectionGapsImprovements = 45,
  CB1Perception = 46,
  CB2Perception = 47,
  CB3Perception = 48,
  CB4Perception = 49,
  CB5Perception = 50,
  CB6Perception = 51,
  CESectionGapsImprovements = 52,
  CE1Perception = 53,
  CE2Perception = 54,
  CVSectionGapsImprovements = 55,
  ClinicalEvidenceNeeds = 56,
  ComparatorRelevance = 57,
  CurrentHTAReimbursementOutcomes = 58,
  CurrentManagementAndCoverage = 59,
  DecisionDrivers = 60,
  DiseaseBurden = 61,
  DriversOfClinicalValueToOptimizePAndT = 62,
  DriversOfTheCompetitiveLandscapeToOptimizePAndT = 63,
  DriversOfUnmetNeedToOptimizePAndT = 64,
  EV1Perception = 65,
  EV2Perception = 66,
  EV3Perception = 67,
  EconomicEvidenceNeeds = 68,
  EfficacyBenefitPerceptions = 69,
  EndpointImportance = 70,
  EndpointRelevance = 71,
  EvidenceGaps = 72,
  ExpectedHTAReimbursementOutcomes = 73,
  ExpectedManagementIrrespectiveOfPrice = 74,
  ExtentToWhichVSSupportsReimbursement = 75,
  FinalConsiderations = 76,
  FinalRecommendations = 77,
  FutureEvidenceExpectations = 78,
  FutureUtilizationManagementApproach = 79,
  GaborGrangerExercise = 80,
  IntroOverview = 81,
  LandscapeEvolutionAndPipelineAwareness = 82,
  ListPricePotential = 83,
  MOASectionGapsImprovements = 84,
  MOA1Perception = 85,
  ManagedEntryAgreementAlternativeContracting = 86,
  MessageRowOptimization = 87,
  NetPricePotential = 88,
  OverallCTDesignPerception = 89,
  OverallImpressionOfVS = 90,
  PopulationRelevance = 91,
  PriceBenchmarks = 92,
  PriceComparator = 93,
  RespondentProfile = 94,
  SafetyTolerabilityProfilePerceptions = 95,
  ScenarioXOpportunityVsBaseCase = 96,
  ScenarioYOpportunityVsBaseCase = 97,
  ScenarioZOpportunityVsBaseCase = 98,
  StandardOfCare = 99,
  TopMessages = 100,
  TrialDurationRelevance = 101,
  UNSectionGapsImprovements = 102,
  UN1Perception = 103,
  UN2Perception = 104,
  UN3Perception = 105,
  VanWesterndropExercise = 106,
  UnmetNeedsMessages = 107,
  MoAMessages = 108,
  ClinicalBenefitMessages = 109,
  ComparativeEfficacyMessages = 110,
  EconomicValueMessages = 111,
  OverallImpressionsAndDecisionMaking = 112,
  MessageFlowOptimization = 113,
}

export enum TagCategory {
  Transcript = 'Transcript Tag',
  Files = 'Files Tag',
  Segmentation = 'Segmentation Tag',
  PatientJourney = 'Patient Journey Tag',
}

export enum PatientJourneyDashboardType {
  Stage = 'Journey Stage',
  Dimension = 'Journey Dimension',
}

export enum PatientJourneyDimensionType {
  SingleStageText = 'Single-Stage Text',
  DimensionWideText = 'Dimension-Wide Text',
}
